import { useQuery } from "@tanstack/react-query";

import { getScorecardAnalysisData } from "../../../data/queries/coaching";
import { AttributeExamples } from "../types";
import { extractLowHighScoring, groupByAttribute } from "../utils/scorecardAnalysisProcessors";

const DEFAULT_EXAMPLES_PER_ATTRIBUTE = 5;

interface UseAttributeExamplesParams {
  timeRange: string;
  timezone: string;
  lensFilter: string;
  userFilter?: string;
  permittedEmails?: string[] | null;
  limit?: number;
  tenantId: string | null;
  enabled?: boolean;
}

export const useAttributeExamples = (params: UseAttributeExamplesParams) => {
  return useQuery<AttributeExamples[], Error>({
    queryKey: [
      "attributeExamples",
      params.timeRange,
      params.timezone,
      params.lensFilter,
      params.userFilter,
      params.permittedEmails,
      params.limit,
      params.tenantId
    ],
    queryFn: async () => {
      const rawData = await getScorecardAnalysisData(params);
      const grouped = groupByAttribute(rawData);
      return extractLowHighScoring(grouped, params.limit || DEFAULT_EXAMPLES_PER_ATTRIBUTE);
    },
    enabled: params.enabled !== false,
    staleTime: 5 * 60 * 1000,
    retry: 2
  });
};
